import React from 'react';
import { motion } from 'framer-motion';
export function OutcomeSection() {
  return <section className="py-20 px-6 max-w-2xl mx-auto text-center" data-id="element-102">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-103">
        <h2 className="font-serif text-3xl text-gold-400 mb-8" data-id="element-104">
          What changes in the house when this works
        </h2>

        <div className="space-y-6 text-lg md:text-xl leading-loose-p text-cream-50 mb-12" data-id="element-105">
          <p data-id="element-106">The baby can still wake up.</p>
          <p data-id="element-107">But the night stops being a negotiation.</p>
          <p data-id="element-108">You stop having to:</p>

          <div className="flex flex-wrap justify-center gap-3 my-6" data-id="element-109">
            {['plead', 'prove', 'justify', 'manage moods', 'carry the load'].map((word, i) => <span key={i} className="px-4 py-2 bg-navy-800 rounded-full text-sm text-cream-100/80 border border-white/5" data-id="element-110">
                {word}
              </span>)}
          </div>

          <p data-id="element-111">Instead, you run a system.</p>
          <p data-id="element-112">And the system gives you back something you forgot existed:</p>
          <p className="font-serif text-2xl text-gold-400" data-id="element-113">
            a protected stretch of sleep.
          </p>
        </div>

        {/* 3 Night Rule */}
        <div className="bg-gradient-to-b from-navy-800 to-navy-900 p-8 rounded-2xl border border-gold-400/10" data-id="element-114">
          <h3 className="font-serif text-2xl text-cream-50 mb-6" data-id="element-115">
            The 3-night rule
          </h3>
          <div className="space-y-4 text-left" data-id="element-116">
            <div className="flex gap-4" data-id="element-117">
              <span className="font-bold text-gold-400 w-16" data-id="element-118">Night 1</span>
              <span className="text-cream-100" data-id="element-119">Detox from chaos.</span>
            </div>
            <div className="flex gap-4" data-id="element-120">
              <span className="font-bold text-gold-400 w-16" data-id="element-121">Night 2</span>
              <span className="text-cream-100" data-id="element-122">
                The system starts to stick.
              </span>
            </div>
            <div className="flex gap-4" data-id="element-123">
              <span className="font-bold text-gold-400 w-16" data-id="element-124">Night 3</span>
              <span className="text-cream-100" data-id="element-125">Where you feel the relief.</span>
            </div>
          </div>
          <p className="mt-8 text-cream-100/60 italic text-sm" data-id="element-126">
            Then you do a 12-minute review and adjust one thing. Not ten. One.
          </p>
        </div>
      </motion.div>
    </section>;
}